import React from 'react'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { selectActiveInvestment } from '@mobi/betslip/Store/Workflow/selectors'
import { colors, radius, spacing } from '@mobi/component-library/Foundations'
import { AnimatedHeightToggle } from '@mobi/component-library/Misc/AnimatedHeightToggle'
import { ButtonsSection, Keypad, SummarySection } from './Components'

const enum LocalConstants {
  ExpandTimingMs = 250,
}

export const Footer: React.FC = () => {
  const shouldDisplayKeypad = !!useSelector(selectActiveInvestment)

  return (
    <WrapperStyled data-testid='BetSlip.Footer'>
      <AnimatedHeightToggle
        isExpanded={shouldDisplayKeypad}
        timeoutMs={LocalConstants.ExpandTimingMs}
      >
        <Keypad />
      </AnimatedHeightToggle>

      <AnimatedHeightToggle
        isExpanded={!shouldDisplayKeypad}
        timeoutMs={LocalConstants.ExpandTimingMs}
      >
        <SummarySection />
      </AnimatedHeightToggle>

      <ButtonsSection />
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  boxSizing: 'border-box',
  padding: spacing.md,
  paddingBottom: `calc(var(--safe-area-inset-bottom, 0) + ${spacing.md})`,
  borderTopLeftRadius: radius.lgx4,
  borderTopRightRadius: radius.lgx4,
  backgroundColor: colors.lavender[900],
})
